<template>
  <v-timeline v-if="lines" dense>
    <TimelineItem
      v-for="line in lines"
      :line="line"
      :key="line.timestamp"
    />
  </v-timeline>
</template>
<script>
import TimelineItem from './TimelineItem.vue'

export default {
  name: 'Timeline',

  props: {
    lines: Array
  },

  components: { TimelineItem }
}
</script>
